module.exports = __webpack_public_path__ + "static/media/seguimiento.53e4bad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/seguimiento.png
// module id = 1211
// module chunks = 0